import { InlineSpinner } from "@graffer-inc/console-design-kit";
import * as React from "react";
import ReactLoading from "react-loading";

interface LoaderProps {
  children: React.ReactNode;
  isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ children, isLoading }) => {
  return isLoading ? (
    <div className="p-4">
      <InlineSpinner />
    </div>
  ) : (
    <>{children}</>
  );
};

export const Loading = ({
  height = "100%",
  width = "100%",
  color,
}: {
  height?: string;
  width?: string;
  color?: string;
}) => (
  <div className="has-text-centered">
    <ReactLoading
      type="spin"
      color={color}
      className="c-loading"
      height={height}
      width={width}
    />
  </div>
);
